/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { BrickLoader, FlexContainer, Table, theme } from "@nordcloud/gnui";
import { FAILURES_LIMIT } from "./consts";
import { countCellCss, iconCellCss, nameCellCss } from "./styles";

export function DistinctUpdateFailuresSkeleton() {
  return (
    <>
      {Array.from({ length: FAILURES_LIMIT }, (_, index) => (
        <Table.tr key={index}>
          <Table.td css={iconCellCss}>
            <FlexContainer alignItems="center">
              <div
                css={{ width: "1.5rem", marginRight: theme.spacing.spacing03 }}
              >
                <BrickLoader height="1.3rem" />
              </div>
              <div
                css={{ width: "1.5rem", marginRight: theme.spacing.spacing03 }}
              >
                <BrickLoader height="1.3rem" />
              </div>
            </FlexContainer>
          </Table.td>
          <Table.td css={nameCellCss}>
            <BrickLoader height="1.3rem" />
          </Table.td>
          <Table.td css={countCellCss}>
            <BrickLoader height="1.3rem" />
          </Table.td>
        </Table.tr>
      ))}
    </>
  );
}
